import payment from './payment'

const demand = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {},
  modules: {
    payment
  }
}

export default demand
